import $ from "jquery";
import axios from "axios";
import {getClientIdentificator} from "./clientIdentificator/clientIdentificator";
import {makeFormData} from "./modals/general-form-maker";
import {renderSubscriptionErrorByResponse} from "./modals/render-response";

export const SUBSCRIBED = 'subscribed';

const SUBSCRIPTION_LINK = '/rest/subscriptions/email-subscription/create';

const EMAIL_PLACEHOLDER = '%email%';

export const subscribeBlog = () => {
    const subscribeDiv = $('.blog__subscribe:visible');
    const subscribeButton = subscribeDiv.find('.button');

    subscribeButton.click(() => {
        eventsToSubscriptionButton(subscribeDiv);
    })
};

const eventsToSubscriptionButton = async (modalSelector) => {
    let data = makeFormData(modalSelector);

    data.clientId = await getClientIdentificator();

    axios.post(SUBSCRIPTION_LINK, data)
        .then((response) => {
            setSubscribed();

            const html = modalSelector.find('.blog__subscribe-result').html();
            const email = modalSelector.find('[name="email"]').val();

            modalSelector.html(html.replace(EMAIL_PLACEHOLDER, email));
        })
        .catch((error) => {
            renderSubscriptionErrorByResponse(error.response, $(modalSelector));
        });
};

const setSubscribed = () => {
    window.localStorage.setItem(SUBSCRIBED, 'true');
};
